import { Table, TableBody, TableCell, TableCellLayout, TableRow, Text } from "@fluentui/react-components";
import { Col, Container, Row } from "react-grid-system";
import IPassword from "../../../models/password/IPassword";
import { useTranslation } from "react-i18next";
import IAttribute from "../../../models/IAttribute";

export default function Attributes(props: { password: IPassword }) {
    const { t } = useTranslation();
    
    return (
        <Container fluid>
            <Row align="center">
                <Col>
                    <Table>
                        <TableBody>
                            {
                                props.password.attributes.map((attribute: IAttribute, index: number) => (
                                    <TableRow key={index}>
                                        <TableCell>
                                            <TableCellLayout>
                                                {attribute.name}
                                            </TableCellLayout>
                                        </TableCell>
                                        <TableCell>
                                            <TableCellLayout>
                                                {attribute.value}
                                            </TableCellLayout>
                                        </TableCell>
                                    </TableRow>
                                ))
                            }
                        </TableBody>
                    </Table>
                </Col>
            </Row>
            {
                props.password.notes &&
                <Row>
                    <Col xs={12}>
                        <div>
                            <strong>{t("passwords.notes")}</strong>
                        </div>
                        <div style={{ whiteSpace: "pre-wrap" }} dangerouslySetInnerHTML={{ __html: props.password.notes || "" }} />
                    </Col>
                </Row>
            }
        </Container>
    );
}